export default (data) => {
	return JSON.parse(JSON.stringify(data));
};



// WEBPACK FOOTER //
// ./src/assets/js/clone.js